export default "/images/0e64343dea1b3b56000da8b88a7c9bf8.avif";